
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3gadb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2caa4a7e85ae2d24$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $6yeVm = parcelRequire("6yeVm");

var $ee7An = parcelRequire("ee7An");

var $cr6pC = parcelRequire("cr6pC");

var $g6aM3 = parcelRequire("g6aM3");

var $if5rb = parcelRequire("if5rb");

var $g9Srd = parcelRequire("g9Srd");
var $fT2ta = parcelRequire("fT2ta");

var $dh538 = parcelRequire("dh538");

var $lqsSp = parcelRequire("lqsSp");

var $caX7N = parcelRequire("caX7N");

var $dTk3A = parcelRequire("dTk3A");

var $29bV2 = parcelRequire("29bV2");

var $8v9yf = parcelRequire("8v9yf");

var $3VJDH = parcelRequire("3VJDH");

var $5CLwS = parcelRequire("5CLwS");

var $btyPJ = parcelRequire("btyPJ");
const $2caa4a7e85ae2d24$var$tooltipZIndex = (0, $dTk3A.layers).tooltip();
const $2caa4a7e85ae2d24$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
// Inverts motion direction
const $2caa4a7e85ae2d24$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $2caa4a7e85ae2d24$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $2caa4a7e85ae2d24$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
component: Container = (0, $5CLwS.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $ee7An.default), onHide: onHide = (0, $ee7An.default), canAppear: canAppear, hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = false }) {
    const tooltipPosition = position === 'mouse' ? mousePosition : position;
    const onShowHandler = (0, $6yeVm.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$2caa4a7e85ae2d24$var$analyticsAttributes
    });
    const onHideHandler = (0, $6yeVm.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$2caa4a7e85ae2d24$var$analyticsAttributes
    });
    const apiRef = (0, $gwFzn.useRef)(null);
    const [state, setState] = (0, $gwFzn.useState)('hide');
    const targetRef = (0, $gwFzn.useRef)(null);
    const containerRef = (0, $gwFzn.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $gwFzn.useCallback)((node)=>{
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    const stableState = (0, $g6aM3.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    const onShowHandlerStable = (0, $g6aM3.default)(onShowHandler);
    const onHideHandlerStable = (0, $g6aM3.default)(onHideHandler);
    const delayStable = (0, $g6aM3.default)(delay);
    const canAppearStable = (0, $g6aM3.default)(canAppear);
    const hasCalledShowHandler = (0, $gwFzn.useRef)(false);
    const start = (0, $gwFzn.useCallback)((api)=>{
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $gwFzn.useCallback)(()=>{
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    const abort = (0, $gwFzn.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $gwFzn.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        return (0, $29bV2.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ apiRef.current?.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []);
    const tryShowTooltip = (0, $gwFzn.useCallback)((source)=>{
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !canAppearStable.current?.()) return;
        const entry = {
            source: source,
            delay: delayStable.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        const api = (0, $8v9yf.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    const hideTooltipOnEsc = (0, $gwFzn.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $cr6pC.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $gwFzn.useEffect)(()=>{
        if (state === 'hide') return 0, $ee7An.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $d8F95.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $gwFzn.useCallback)(()=>{
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    const onClick = (0, $gwFzn.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $gwFzn.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        const source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $btyPJ.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $gwFzn.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = position === 'mouse' ? (event)=>{
        if (apiRef.current?.isActive()) apiRef.current.mousePosition = (0, $btyPJ.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    const onMouseOverTooltip = (0, $gwFzn.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $gwFzn.useCallback)(()=>{
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (targetRef.current && !targetRef.current.matches(':focus-visible') && (0, $dh538.fg)('platform-tooltip-focus-visible')) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    const onBlur = (0, $gwFzn.useCallback)(()=>{
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $gwFzn.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    const handleOpenLayerObserverCloseSignal = (0, $gwFzn.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $if5rb.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && ((0, $dh538.fg)('platform_dst_open_layer_observer_close_layers') ? shouldRenderTooltipChildren : true),
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    const getReferenceElement = ()=>{
        if (position === 'mouse' && apiRef.current?.mousePosition) return apiRef.current?.mousePosition;
        return targetRef.current || undefined;
    };
    const tooltipIdForHiddenContent = (0, $3VJDH.default)('tooltip', shouldRenderHiddenContent);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = `${testId}--container`;
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    const isChildrenAFunction = typeof children === 'function';
    (0, $gwFzn.useEffect)(()=>{
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        const target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return ()=>target.removeAttribute('aria-describedby');
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    const hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent,
        children: typeof content === 'function' ? content({}) : content
    }) : null;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
            // attribute back into the tooltipTriggerProps and make it required
            // instead of optional in `types`
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    children({
                        ...tooltipTriggerProps,
                        'aria-describedby': tooltipIdForHiddenContent,
                        ref: setDirectRef
                    }),
                    hiddenContent
                ]
            }) : /*#__PURE__*/ (0, $7UHDa.jsxs)(CastTargetContainer, {
                ...tooltipTriggerProps,
                ref: setImplicitRefFromChildren,
                /**
     * TODO: Why is role="presentation" added?
     * - Is it only to "remove" the `Container` from screen readers?
     * - Why is it added only to the `Container` but not to `tooltipTriggerProps`?
     * - Should `role="presentation"` only be used if `shouldRenderHiddenContent == false`?
     */ role: "presentation",
                children: [
                    children,
                    hiddenContent
                ]
            }),
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $caX7N.default), {
                zIndex: $2caa4a7e85ae2d24$var$tooltipZIndex,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lqsSp.Popper), {
                    placement: tooltipPosition,
                    referenceElement: getReferenceElement(),
                    strategy: strategy,
                    children: ({ ref: ref, style: style, update: update, placement: placement })=>{
                        // Invert the entrance and exit directions.
                        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
                        // This gives the effect the tooltip is appearing from the target
                        const direction = position === 'mouse' ? undefined : $2caa4a7e85ae2d24$var$invertedDirection[$2caa4a7e85ae2d24$var$getDirectionFromPlacement(placement)];
                        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $g9Srd.default), {
                            appear: true,
                            children: shouldRenderTooltipChildren && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fT2ta.default), {
                                distance: "constant",
                                entranceDirection: direction,
                                exitDirection: direction,
                                onFinish: onAnimationFinished,
                                duration: state !== 'show-immediate' ? 'medium' : 'none',
                                children: ({ className: className })=>/*#__PURE__*/ (0, $7UHDa.jsx)(Container, {
                                        ref: ref,
                                        /**
               * "Tooltip" classname is a hook used by tests to manipulate
               * and hide tooltips, including in VR snapshots
               */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                        className: `Tooltip ${className}`,
                                        style: {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...style,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...ignoreTooltipPointerEvents && {
                                                pointerEvents: 'none'
                                            }
                                        },
                                        truncate: truncate,
                                        placement: tooltipPosition,
                                        testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                                        onMouseOut: onMouseOut,
                                        onMouseOver: onMouseOverTooltip,
                                        children: typeof content === 'function' ? content({
                                            update: update
                                        }) : content
                                    })
                            })
                        });
                    }
                })
            }) : null
        ]
    });
}
$2caa4a7e85ae2d24$var$Tooltip.displayName = 'Tooltip';
var $2caa4a7e85ae2d24$export$2e2bcd8739ae039 = $2caa4a7e85ae2d24$var$Tooltip;

});
parcelRegister("6yeVm", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $5975fb3f46b99358$export$1a04351537078b55);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $fTXBo = parcelRequire("fTXBo");
function $5975fb3f46b99358$export$1a04351537078b55({ fn: fn, action: action, componentName: componentName, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $fTXBo.useTrackedRef)(analyticsData);
    const fnRef = (0, $fTXBo.useTrackedRef)(fn);
    const handler = (0, $gwFzn.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("cr6pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed62970505a64678$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $4JWgN = parcelRequire("4JWgN");
function $ed62970505a64678$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $gwFzn.useRef)(false);
    const onKeyDown = (0, $gwFzn.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $4JWgN.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $gwFzn.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        return (0, $d8F95.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("4JWgN", function(module, exports) {

$parcel$export(module.exports, "KEY_UP", () => $86459c7074d8d3c8$export$390330c10ff2b9a1);
$parcel$export(module.exports, "KEY_DOWN", () => $86459c7074d8d3c8$export$a80636c6f41931fe);
$parcel$export(module.exports, "KEY_HOME", () => $86459c7074d8d3c8$export$4af703091671bc);
$parcel$export(module.exports, "KEY_END", () => $86459c7074d8d3c8$export$e2bc30913faa5db7);
$parcel$export(module.exports, "KEY_TAB", () => $86459c7074d8d3c8$export$10f6869ed0a7d75b);
$parcel$export(module.exports, "KEY_ENTER", () => $86459c7074d8d3c8$export$8152f929a25a0ff4);
$parcel$export(module.exports, "KEY_SPACE", () => $86459c7074d8d3c8$export$e51a3576c045c8d5);
$parcel$export(module.exports, "ESCAPE", () => $86459c7074d8d3c8$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ const $86459c7074d8d3c8$export$390330c10ff2b9a1 = 'ArrowUp';
const $86459c7074d8d3c8$export$a80636c6f41931fe = 'ArrowDown';
const $86459c7074d8d3c8$export$4af703091671bc = 'Home';
const $86459c7074d8d3c8$export$e2bc30913faa5db7 = 'End';
const $86459c7074d8d3c8$export$10f6869ed0a7d75b = 'Tab';
const $86459c7074d8d3c8$export$8152f929a25a0ff4 = 'Enter';
const $86459c7074d8d3c8$export$e51a3576c045c8d5 = 'Space';
const $86459c7074d8d3c8$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("g6aM3", function(module, exports) {

$parcel$export(module.exports, "default", () => $67db7a8b3e03080f$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
function $67db7a8b3e03080f$export$2e2bcd8739ae039(value) {
    const ref = (0, $gwFzn.useRef)(value);
    (0, $gwFzn.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("29bV2", function(module, exports) {

$parcel$export(module.exports, "register", () => $de67ee6726340b5c$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $d8F95 = parcelRequire("d8F95");
const $de67ee6726340b5c$var$registrations = new Set();
let $de67ee6726340b5c$var$cleanupEndEventListeners = null;
function $de67ee6726340b5c$var$onDragStart() {
    if ($de67ee6726340b5c$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $de67ee6726340b5c$var$cleanupEndEventListeners = (0, $d8F95.bindAll)(window, [
        {
            type: 'dragend',
            listener: $de67ee6726340b5c$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $de67ee6726340b5c$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $de67ee6726340b5c$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($de67ee6726340b5c$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $de67ee6726340b5c$var$onDragEnd() {
    $de67ee6726340b5c$var$cleanupEndEventListeners?.();
    $de67ee6726340b5c$var$cleanupEndEventListeners = null;
    const clone = Array.from($de67ee6726340b5c$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $de67ee6726340b5c$var$bindStartEvents() {
    return (0, $d8F95.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $de67ee6726340b5c$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $de67ee6726340b5c$var$onDragStart
        }
    ]);
}
let $de67ee6726340b5c$var$cleanupStartEventListeners = null;
function $de67ee6726340b5c$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$de67ee6726340b5c$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $de67ee6726340b5c$var$cleanupStartEventListeners = $de67ee6726340b5c$var$bindStartEvents();
    $de67ee6726340b5c$var$registrations.add(registration);
    /**
	 * The reasoning for this behavior is so that if a tooltip mounts during
	 * a drag it can still be suppressed.
	 *
	 * We use a separate callback instead of onDragStart to avoid infinite loops.
	 */ registration.onRegister({
        isDragging: $de67ee6726340b5c$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $de67ee6726340b5c$var$registrations.delete(registration);
        if ($de67ee6726340b5c$var$registrations.size === 0) {
            $de67ee6726340b5c$var$cleanupStartEventListeners?.();
            $de67ee6726340b5c$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("8v9yf", function(module, exports) {

$parcel$export(module.exports, "show", () => $65794b5be37fefa8$export$57bf213be019eeb0);

var $fR68N = parcelRequire("fR68N");
let $65794b5be37fefa8$var$active = null;
function $65794b5be37fefa8$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($65794b5be37fefa8$var$active && $65794b5be37fefa8$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $fR68N.clearScheduled)();
            $65794b5be37fefa8$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $fR68N.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $fR68N.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $fR68N.scheduleTimeout)(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        const showImmediately = Boolean($65794b5be37fefa8$var$active && $65794b5be37fefa8$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($65794b5be37fefa8$var$active) {
            (0, $fR68N.clearScheduled)();
            $65794b5be37fefa8$var$active.entry.hide({
                isImmediate: true
            });
            $65794b5be37fefa8$var$active.entry.done();
            $65794b5be37fefa8$var$active = null;
        }
        // this tooltip is now the active tooltip
        $65794b5be37fefa8$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $fR68N.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("fR68N", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", () => $376da88e101dc401$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $376da88e101dc401$export$5f4d6617421d489b);
let $376da88e101dc401$var$delayId = null;
function $376da88e101dc401$export$eaf678f6f93f5250() {
    if ($376da88e101dc401$var$delayId != null) {
        window.clearTimeout($376da88e101dc401$var$delayId);
        $376da88e101dc401$var$delayId = null;
    }
}
function $376da88e101dc401$export$5f4d6617421d489b(fn, delay) {
    $376da88e101dc401$export$eaf678f6f93f5250();
    $376da88e101dc401$var$delayId = window.setTimeout(()=>{
        $376da88e101dc401$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("3VJDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf844e3a7d1984bc$export$2e2bcd8739ae039);

var $c0qxy = parcelRequire("c0qxy");
function $cf844e3a7d1984bc$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $c0qxy.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});

parcelRegister("5CLwS", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf8463e499a7348e$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $afneb = parcelRequire("afneb");
const $bf8463e499a7348e$var$baseStyles = null;
const $bf8463e499a7348e$var$truncateStyles = null; /**
                              * Used as the default tooltip container component for the exported `Tooltip` component.
                              * Adds some styles to the tooltip primitive.
                              */ 
const $bf8463e499a7348e$var$TooltipContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $afneb.default), {
        ref: ref,
        style: style,
        className: (0, $35pXk.default)([
            "_2rko1sit _11c8dcr7 _vchhusvi _p12fp3fh _bfhkcdhy _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        children: children
    });
});
$bf8463e499a7348e$var$TooltipContainer.displayName = 'TooltipContainer';
var $bf8463e499a7348e$export$2e2bcd8739ae039 = $bf8463e499a7348e$var$TooltipContainer;

});
parcelRegister("afneb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a3fad30e262233e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $dTk3A = parcelRequire("dTk3A");
const $9a3fad30e262233e$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
const $9a3fad30e262233e$var$primitiveStyles = (0, $3jLHL.css)({
    zindex: `var(${$9a3fad30e262233e$var$VAR_PRIMITIVE_ZINDEX})`,
    cursor: `default`
});
/**
 * The lower level component for rendering a tooltip.
 */ const $9a3fad30e262233e$var$TooltipPrimitive = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
    const styleWithZIndex = {
        ...style,
        [$9a3fad30e262233e$var$VAR_PRIMITIVE_ZINDEX]: (0, $dTk3A.layers).tooltip()
    };
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: styleWithZIndex,
        "data-testid": testId ? `${testId}--wrapper` : undefined
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        role: "tooltip",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // Because the tooltip should not be focusable, there is no reason to have key events.
        /* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
        /* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */ onMouseOver: onMouseOver,
        css: $9a3fad30e262233e$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$9a3fad30e262233e$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $9a3fad30e262233e$export$2e2bcd8739ae039 = $9a3fad30e262233e$var$TooltipPrimitive;

});


parcelRegister("btyPJ", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", () => $46554e5432af7c58$export$642213d516a9b928);
function $46554e5432af7c58$export$642213d516a9b928(mouseCoordinates) {
    const safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    const getBoundingClientRect = ()=>({
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        });
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});



//# sourceMappingURL=ErrorComponent.67f2b04e.js.map
